import { BackButton, BackButtonProps } from '../../00-atoms/back-button/back-button.tsx';

export type ModalBackButtonProps = BackButtonProps;

/**
 * We use the same visual back button in many modals.
 * It can be enabled via the modal props.
 */
export const ModalBackButton = BackButton;
